import EmptyState from "../store/emptyState";
import { SearchActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const {
  CLEAR_RESULTS,
  REQUEST_ERROR,
  REQUEST_FULFILLED,
  SET_TERM,
  UPDATE_HISTORY,
  TOGGLE_SEARCH_DRAWER,
  SET_SETTINGS
} = SearchActionConstants;

const search = (state = EmptyState.search, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;

  switch (type) {
    case REQUEST_FULFILLED:
      return Object.assign({}, state, {
        results: action.payload
      });

    case CLEAR_RESULTS:
      return Object.assign({}, state, {
        results: []
      });

    case REQUEST_ERROR:
      return Object.assign({}, state, {
        error: action.payload,
        results: []
      });

    case UPDATE_HISTORY:
      return Object.assign({}, state, {
        historySearchTerms: action.payload || []
      });

    case SET_TERM:
      return Object.assign({}, state, {
        searchTerm: action.payload
      });

    case TOGGLE_SEARCH_DRAWER:
      return Object.assign({}, state, {
        searchActive: action.payload
      });

    case SET_SETTINGS: {
      return Object.assign({}, state, {
        settings: action.payload
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.search,
        EmptyState.search
      );
  }
};

export default search;
